<div class="row">
    <div class="col-lg-4 d-flex flex-column">
        <div class="col-12 grid-margin stretch-card">
            <div class="card card-rounded">
                <div class="card-body">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="row">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div>
                                        <h4 class="card-title card-title-dash">Running Strategies</h4>
                                    </div>
                                </div>
                                <div ng-if="running_strategies.length > 0" *ngFor="let strategy of running_strategies">
                                    <div class="wrapper d-flex align-items-center justify-content-between border-bottom">
                                        <div class="d-flex">
                                            <div class="wrapper ms-3">
                                                <p class="ms-1 mb-1 fw-bold">{{strategy.name}}</p>
                                                <table class="table table-sm">
                                                    <tbody>
                                                        <tr *ngFor="let leg of strategy.legs">
                                                            <td>
                                                                <small class="text-muted mb-0 fw-bold">{{strategy[leg].strike_ot}}</small>
                                                            </td>
                                                            <td>
                                                                <small class="text-muted mb-0">{{strategy[leg].net_qty}}</small>
                                                            </td>
                                                            <td>
                                                                <small class="text-muted mb-0" [ngClass]="getPnLClass(strategy[leg].pnl)">{{getFormattedPnL(strategy[leg].pnl)}}</small>
                                                            </td>
                                                            <td>
                                                                <span><i class="bi" [ngClass]="getPositionCloseIconClass(strategy[leg])" (click)="onCloseClick(strategy, leg)"></i></span>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="text-muted text-small">
                                            <span class="fw-bold" [ngClass]="getPnLClass(strategy.pnl)">{{getFormattedPnL(strategy.pnl)}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="running_strategies.length == 0">
                                    <span class="text-secondary">No Strategies Found.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex">
            <p class="me-auto fw-bold ms-3">Today's PNL</p>
            <h3 class="me-2"><i class="bi" [ngClass]="getPnLIconClass(strategies_total)"></i><span  [ngClass]="getPnLClass(strategies_total)">{{getTotalPnl()}}</span></h3>
        </div>
        <div class="col-12 grid-margin stretch-card">
            <div class="card card-rounded">
                <div class="card-body">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="row">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div>
                                        <h4 class="card-title card-title-dash">Completed Strategies</h4>
                                    </div>
                                </div>
                                <div ng-if="completed_strategies.length > 0" *ngFor="let strategy of completed_strategies">
                                    <div class="wrapper d-flex align-items-center justify-content-between border-bottom">
                                        <div class="d-flex">
                                            <div class="wrapper ms-3">
                                                <p class="ms-1 mb-1 fw-bold">{{strategy.name}}</p>
                                                <table class="table table-sm">
                                                    <tbody>
                                                        <tr *ngFor="let leg of strategy.legs">
                                                            <td>
                                                                <small class="text-muted mb-0 fw-bold">{{strategy[leg].strike_ot}}</small>
                                                            </td>
                                                            <td>
                                                                <small class="text-muted mb-0"></small>
                                                            </td>
                                                            <td>
                                                                <small class="text-muted mb-0" [ngClass]="getPnLClass(strategy[leg].pnl)">{{getFormattedPnL(strategy[leg].pnl)}}</small>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div class="text-muted text-small">
                                            <span class="fw-bold" [ngClass]="getPnLClass(strategy.pnl)">{{getFormattedPnL(strategy.pnl)}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="completed_strategies.length == 0">
                                    <span class="text-secondary">No Strategies Found.</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-lg-8 d-flex flex-column">
        <div class="row flex-grow">
            <div class="col-12 grid-margin stretch-card">
                <div class="card card-rounded">
                    <div class="card-body">
                        <div class="d-sm-flex justify-content-between align-items-start">
                            <div>
                                <h4 class="card-title card-title-dash">Overview</h4>
                            </div>
                            <div>
                                <div class="dropdown">
                                    <button class="btn btn-secondary dropdown-toggle toggle-dark btn mb-0 me-0"
                                        type="button" id="dropdownMenuButton2" data-bs-toggle="dropdown"
                                        aria-haspopup="true" aria-expanded="false"> {{ selected_report.text }} </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                                        <a class="dropdown-item" (click)="onItemSelected('this_week')">This Week</a>
                                        <a class="dropdown-item" (click)="onItemSelected('this_month')">This Month</a>
                                        <a class="dropdown-item" (click)="onItemSelected('this_year')">This Year</a>
                                        <a class="dropdown-item" (click)="onItemSelected('last_5_days')">Last 5 Days</a>
                                        <a class="dropdown-item" (click)="onItemSelected('last_10_days')">Last 10 Days</a>
                                        <a class="dropdown-item" (click)="onItemSelected('last_week')">Last Week</a>
                                        <a class="dropdown-item" (click)="onItemSelected('last_month')">Last Month</a>
                                        <a class="dropdown-item" (click)="onItemSelected('last_3_months')">Last 3 Months</a>
                                        <a class="dropdown-item" (click)="onItemSelected('last_6_months')">Last 6 Months</a>
                                        <a class="dropdown-item" (click)="onItemSelected('last_year')">Last Year</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-sm-flex align-items-center mt-1 justify-content-between">
                            <div class="d-sm-flex align-items-center mt-4 justify-content-between">
                                <h2 class="me-2 fw-bold"> {{ getFormattedPnL(report_pnl) }}</h2>
                            </div>
                        </div>
                        <div class="chartjs-bar-wrapper mt-3">
                            <div class="chartjs-size-monitor">
                                <div class="chartjs-size-monitor-expand">
                                    <div class=""></div>
                                </div>
                                <div class="chartjs-size-monitor-shrink">
                                    <div class=""></div>
                                </div>
                            </div>
                            <canvas id="marketingOverview" style="display: block; height: 150px; width: 750px;"
                                width="900" height="180" class="chartjs-render-monitor"></canvas>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div id="closeLegConfirmationModal" class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">ALERT</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="closeSelectedLeg(0, closeLegParams)"></button>
        </div>
        <div class="modal-body">
          <p>Are you sure want to close the <span class="fw-bold">{{ closeLegParams.selected_leg }}</span> leg?</p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" (click)="closeSelectedLeg(0, closeLegParams)">Cancel</button>
          <button type="button" class="btn btn-primary" (click)="closeSelectedLeg(1, closeLegParams)">OK</button>
        </div>
      </div>
    </div>
</div>
